import { render, staticRenderFns } from "./product_unique_code_create.vue?vue&type=template&id=2aa1c372&scoped=true"
import script from "./product_unique_code_create.vue?vue&type=script&lang=js"
export * from "./product_unique_code_create.vue?vue&type=script&lang=js"
import style0 from "./product_unique_code_create.vue?vue&type=style&index=0&id=2aa1c372&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1c372",
  null
  
)

export default component.exports